module.exports = __webpack_public_path__ + "static/img/Visualization11.fba544a1.png";